module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_online-6d748c1f8f26972a89e9cebd071d0b8f.webp";